/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckAllowedDocumentFormat {
    BOOKLET = 'BOOKLET',
    ID_CARD = 'ID_CARD',
    EMBASSY_VISA = 'EMBASSY_VISA',
    PAPER = 'PAPER',
    PDF = 'PDF'
}


export function instanceOfPaxCheckAllowedDocumentFormat(value: any): boolean {
    for (const key in PaxCheckAllowedDocumentFormat) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckAllowedDocumentFormat, key)) {
            if (PaxCheckAllowedDocumentFormat[key as keyof typeof PaxCheckAllowedDocumentFormat] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckAllowedDocumentFormatFromJSON(json: any): PaxCheckAllowedDocumentFormat {
    return PaxCheckAllowedDocumentFormatFromJSONTyped(json, false);
}

export function PaxCheckAllowedDocumentFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAllowedDocumentFormat {
    return json as PaxCheckAllowedDocumentFormat;
}

export function PaxCheckAllowedDocumentFormatToJSON(value?: PaxCheckAllowedDocumentFormat | null): any {
    return value as any;
}

export function PaxCheckAllowedDocumentFormatToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckAllowedDocumentFormat {
    return value as PaxCheckAllowedDocumentFormat;
}

